export default {
	FETCH_REVIEWS: 'FETCH_REVIEWS',
	FETCH_REVIEWS_SUCCESS: 'FETCH_REVIEWS_SUCCESS',
	REVIEWS_PER_PAGE: 25,
	INCREMENT_BY: 5,
	MAX_SHOWN_BEFORE_CTA: 3,
	TK_REVIEW_MORE_OR_LESS_CHAR_LIMIT: 180,
	GOOGLE_REVIEW_MORE_OR_LESS_CHAR_LIMIT: 244,
};
